import { Icon, InputAdornment, TextField } from "@mui/material";
import React from "react";
import { NumericFormat } from "react-number-format";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

function TotalCoast({ total = 0, label = "" }) {
  return (
    <div className="location-budget-box">
      <div className="location-budget">
        {label && <label className="label">{label}</label>}
        <NumericFormat
          customInput={TextField}
          name="mailingCost"
          id="mailingCost"
          thousandSeparator
          decimalScale={2}
          allowNegative={false}
          prefix="$"
          suffix=" USD"
          isAllowed={({ floatValue }) =>
            floatValue === undefined || floatValue <= 1000000
          }
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Icon component={RpSvgIcon} name="money1" color="primary" />
                </InputAdornment>
              ),
            },
          }}
          variant="outlined"
          size="small"
          autoComplete="off"
          placeholder="0.00"
          value={total ?? 0}
          disabled
        />
      </div>
    </div>
  );
}

export default TotalCoast;
